module.exports = __webpack_public_path__ + "img/group1.563b946c.png";